import { forwardRef, memo } from "react";

import "./BasicButton.scss";

export default memo(forwardRef(function BasicButton({ children, className, component, startIcon, endIcon, href, ...props }, ref) {

    const ButtonComponent = component ?? (href ? 'a' : 'button');
    const StartIcon = startIcon;
    const EndIcon = endIcon;

    const displayProps = {
        ...props,
        ...(href ? { href } : {}),
    }

    return (
        <ButtonComponent className={`BasicButton ${className}`} {...displayProps} ref={ref}>
            {StartIcon && (
                <span className="BasicButton__starticon">
                    <StartIcon />
                </span>
            )}
            {children}
            {EndIcon && (
                <span className="BasicButton__endicon">
                    <EndIcon />
                </span>
            )}
        </ButtonComponent>
    )
}));